module.exports = __webpack_public_path__ + "img/signal-weak.13101dcc.svg";